export default class Combox {
	constructor(container) {
		this.container = container;

		this.init();
	}

	init() {
		this.assignElement();

		this.helpLayer.style.display = 'none';

		this.openHelpLayer = this.openHelpLayer.bind(this);
		this.closeHelpLayer = this.closeHelpLayer.bind(this);

		this.helpBtn.addEventListener('click', this.openHelpLayer, false);
		this.closeBtn.addEventListener('click', this.closeHelpLayer, false);
	}

	assignElement() {
		this.helpBtn = this.container.querySelector('.ad_help');
		this.helpLayer = this.container.querySelector('.layer_help');
		this.closeBtn = this.helpLayer.querySelector('.btn_close');
	}

	openHelpLayer() {
		this.helpLayer.style.display = 'block';
		this.helpLayer.setAttribute('aria-hidden', false);
	}

	closeHelpLayer(e) {
		this.helpLayer.style.display = 'none';
		this.helpLayer.setAttribute('aria-hidden', true);
		e.stopPropagation();
	}
}


// WEBPACK FOOTER //
// ./src/js/Combox.js